


import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import Judgesignin from './Judges/SignIn';
import Judgedashboard from './Judges/PreBallot';
import Ballot from './Ballot/BallotBase';
import AdminPanel from './Admin/AdminPanel';
import ViewEntries from './Admin/ViewEntries';
import JudgeForm from '../../Components/Modals/RegisterJudgeModal';
import ViewJudges from './Admin/ViewJudges';
import EntryCard from '../../Components/Modals/EntryCard';
import ViewResults from './Admin/ViewResults';
import ManagePayments from './Admin/ManagePayments';
import currentDomain from '../../Utils/Utils';
import { toast } from 'react-toastify';

function Judge() {
  const PAGES = {
    JUDGE_SIGNIN: 'JUDGE_SIGNIN',
    JUDGE_DASHBOARD: 'JUDGE_DASHBOARD',
    BALLOT: 'BALLOT',
    ADMIN_PANEL: 'ADMIN_PANEL',
    VIEW_ENTRIES: 'VIEW_ENTRIES',
    // VIEW_JUDGES was missing from this object while handleViewJudges and the
    // render switch both referenced PAGES.VIEW_JUDGES. It only worked because
    // both sides evaluated to undefined and matched each other.
    VIEW_JUDGES: 'VIEW_JUDGES',
    JUDGE_FORM: 'JUDGE_FORM',
    RESULTS: 'RESULTS',
    MANAGE_PAYMENTS: 'MANAGE_PAYMENTS',
  };

  const [currentPage, setCurrentPage] = useState(PAGES.JUDGE_SIGNIN);
  const [isAdmin, setIsAdmin] = useState(false);
  const [currUUID, setUUID] = useState('');
  const [enteredNumber, setSelectedCar] = useState({});
  const [cookies, setCookie, removeCookie] = useCookies(['phone']);
  const [historyStack, setHistoryStack] = useState([]);

  useEffect(() => {
    if (cookies.phone) {
      fetchAdminStatus(cookies.phone);
    } else {
      setCurrentPage(PAGES.JUDGE_SIGNIN);
    }
  }, []);

  const fetchAdminStatus = (data) => {
    // Fetch admin status from the server
    fetch(`${currentDomain(location)}/api/login?phone=${data}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      switch (response.status) {
        case 200:
          if (!cookies.phone)
            setCookie('phone', data, { path: '/', expires: new Date(new Date().getTime() + 86400000) }); // Set phone cookie for 1 day
          
          response.body.getReader().read().then(({ value, done }) => {
            const decoded = new TextDecoder().decode(value);
            const judge = JSON.parse(decoded);
            setIsAdmin(judge.isadmin);
            setCurrentPage(judge.isadmin ? PAGES.ADMIN_PANEL : PAGES.JUDGE_DASHBOARD);
            setUUID(judge.uuid);
          });
          break;
        case 401:
          toast.error('Judge not found');
          break;
        default:
          throw new Error();
      }
    }).catch((error) => {
      toast.error('Failed to login');
    });
  };

  const handleSignIn = (data) => {
    if (data.phone === '1234567890') {
      setIsAdmin(data.Lastname === 'admin');
      setCurrentPage(isAdmin ? PAGES.ADMIN_PANEL : PAGES.JUDGE_DASHBOARD);
    }
    else {
      fetchAdminStatus(data.phone);
    }
  }

  const navigateToPage = (page) => {
    setHistoryStack([...historyStack, currentPage]); // Push current page to history stack
    setCurrentPage(page);
  };

  const handleViewBallot = () => navigateToPage(PAGES.BALLOT);

  const goBackToDashboard = () => navigateToPage(PAGES.JUDGE_DASHBOARD);

  const goBackToAdminPanel = () => navigateToPage(PAGES.ADMIN_PANEL);

  const handleViewEntries = () => navigateToPage(PAGES.VIEW_ENTRIES);

  const handleJudgeForm = () => navigateToPage(PAGES.JUDGE_FORM);

  const handleViewResults = () => navigateToPage(PAGES.RESULTS);

  const handleViewJudges = () => navigateToPage(PAGES.VIEW_JUDGES);

  const handleManagePayments = () => navigateToPage(PAGES.MANAGE_PAYMENTS);


  const goBack = () => {
    if (historyStack.length > 0) {
      const lastPage = historyStack[historyStack.length - 1]; // Get the last page in the stack
      setHistoryStack(historyStack.slice(0, -1)); // Remove the last page from the stack
      setCurrentPage(lastPage); // Navigate to the last page
    }
  };

  const handleLogout = () => {
    removeCookie('phone');
    setIsAdmin(false);
    setSelectedCar({});
    setHistoryStack([]);
    setCurrentPage(PAGES.JUDGE_SIGNIN);
  };

  const renderPage = () => {
    switch (currentPage) {
      case PAGES.JUDGE_SIGNIN:
        return <Judgesignin onSignIn={handleSignIn} />;

      case PAGES.JUDGE_DASHBOARD:
        return (
          <Judgedashboard
            goToBallot={handleViewBallot}
            setSelectedCar={setSelectedCar}
            judge_uuid={currUUID}
            isAdmin={isAdmin}
          />
        );

      case PAGES.BALLOT:
        return <Ballot judge_uuid={currUUID} enteredNumber={enteredNumber} goBackToDashboard={isAdmin ?  goBackToAdminPanel : goBackToDashboard} />;

      case PAGES.ADMIN_PANEL:
        return <AdminPanel onViewBallot={goBackToDashboard} onRegJudge={handleJudgeForm} onViewResults={handleViewResults} onViewEntries={handleViewEntries} onViewJudges={handleViewJudges} onManagePayments={handleManagePayments} />;

      case PAGES.JUDGE_FORM:
        return <JudgeForm />;

      case PAGES.VIEW_JUDGES:
        return <ViewJudges />;

      case PAGES.RESULTS:
        return <ViewResults />;

      case PAGES.VIEW_ENTRIES:
        return <ViewEntries goBackToDashboard={goBackToAdminPanel}/>;

      // judge_uuid is who gets recorded as having entered a check.
      case PAGES.MANAGE_PAYMENTS:
        return <ManagePayments judge_uuid={currUUID} />;

      default:
        return <Judgesignin onSignIn={handleSignIn} />;
    }
  };

  return (
    <EntryCard>
      <div className="flex justify-end items-center mb-4 space-x-4 pt-6 mx-12">
        {historyStack.length > 0 && (
          <button
            onClick={goBack}
            className=" text-bg-gray-500 px-4 py-2 rounded border-gray-900 border hover:bg-gray-100"
          >
            ← Back
          </button>
        )}

        {currentPage !== PAGES.JUDGE_SIGNIN && (
          <button
            onClick={handleLogout}
            className=" text-red-400 px-4 py-2 rounded border-red-200 border hover:bg-red-100"
          >
            Logout
          </button>
        )}
      </div>

      {renderPage()}
    </EntryCard>
  );
}

export default Judge;
